module.exports = __webpack_public_path__ + "img/Zelo.61fdfcb1.png";